
import * as am4core from '@amcharts/amcharts4/core';

export type ImageExportFormats = keyof am4core.IExportOptions;
export const imageExportFormatsList: (ImageExportFormats)[] = [
    'png',
    'gif',
    'jpg',
    'svg'
];

export const image = {
    _getImageCanvas(img: HTMLImageElement): HTMLCanvasElement {
        const canvas = document.createElement('canvas');
        canvas.width = img.clientWidth;
        canvas.height = img.clientHeight;
        const context = canvas.getContext('2d');
        context.drawImage(img, 0, 0);

        return canvas;
    },
    async _convertImageAsBlob(img: HTMLImageElement, format: ImageExportFormats): Promise<Blob> {
        const canvas = image._getImageCanvas(img);

        let resolve, reject;
        const blobAcquired = new Promise<Blob>((success, error) => {
            resolve = success;
            reject = error;
        });
        canvas.toBlob(resolve, `image/${format}`);

        return blobAcquired;
    },
    _convertImageAsDataUrl(img: HTMLImageElement, format: ImageExportFormats): string {
        const canvas = image._getImageCanvas(img);

        return canvas.toDataURL(`image/${format}`);
    },
    async _getSvgImage(svg: string): Promise<HTMLImageElement> {
        const img = document.createElement('img');
        img.style.visibility = 'hidden';
        img.style.position = 'fixed';
        img.style.top = '100vmax';
        document.body.appendChild(img);

        let resolve, reject;
        const imgLoaded = new Promise<HTMLImageElement>((success, error) => {
            resolve = success;
            reject = error;
        });
        img.onload = function () {
            resolve(img);
        };
        img.src = svg;

        return await imgLoaded;
    },


    async convertSvgDataToBlob(svg: string, format: ImageExportFormats): Promise<Blob> {
        if (format === 'svg') {
            if (svg.startsWith('data')) {
                const svgContent = svg.slice(svg.indexOf(',') + 1);
                svg = decodeURIComponent(svgContent);
            }

            return new Blob([svg], { type: 'data:image/svg' });
        }

        const img = await this._getSvgImage(svg);
        const blob = image._convertImageAsBlob(img, format);

        img.remove();

        return blob;
    },

    async convertSvgDataToDataUrl(svg: string, format: ImageExportFormats): Promise<string> {
        if (format === 'svg') {
            if (svg.startsWith('data')) {
                return svg;
            }

            return `data:image/svg,${svg}`;
        }


        const img = await this._getSvgImage(svg);
        const dataUrl = image._convertImageAsDataUrl(img, format);

        img.remove();

        return dataUrl;
    }
};
